export const rolUserTable = ["SUPER_ADMIN", "ADMIN", "USER", "VIEWER"];

export const teamAreasByFormProject = {
	leader: "LÍDER",
	comercial: "COMERCIAL",
	responsible: "RESPONSABLE",
	desing: "DISEÑO UI/UX",
	art3d: "ARTE 3D",
	web: "PROGRAMACIÓN WEB",
	unity: "PROGRAMACIÓN UNITY",
	planning: "PLANEACIÓN",
};

export const getTeamAreas = (areasNoUse = ["responsible"]) => {
	return Object.entries(teamAreasByFormProject)
		.filter(([key]) => !areasNoUse.includes(key))
		.map(([_, value]) => {
			return value;
		});
};

export const findTeamByValue = (value = "") => {
    return Object.entries(teamAreasByFormProject)
        .find(([_, v]) => {
            return v === value
        })
}

export const teamAreasByFormValue = {
	desing: "design",
	art3d: "art3d",
	web: "web",
	unity: "unity",
	planning: "planning",
};

export const teamAreasByValue = {
	desing: "desing",
	art3d: "art3d",
	web: "web",
	unity: "unity",
	planning: "planning",
};

export const teamAreasData = [
	{
		value: teamAreasByValue.web,
		valueBack: teamAreasByFormValue.web,
		name: teamAreasByFormProject.web,
	},
	{
		value: teamAreasByValue.desing,
		valueBack: teamAreasByFormValue.desing,
		name: teamAreasByFormProject.desing,
	},
	{
		value: teamAreasByValue.art3d,
		valueBack: teamAreasByFormValue.art3d,
		name: teamAreasByFormProject.art3d,
	},
	{
		value: teamAreasByValue.unity,
		valueBack: teamAreasByFormValue.unity,
		name: teamAreasByFormProject.unity,
	},
];

export const teamAreasByFormHoursAdd = () => {
	let areas = [];
	areas.push(
		teamAreasByFormProject.web,
		teamAreasByFormProject.unity,
		teamAreasByFormProject.desing,
		teamAreasByFormProject.planning,
		teamAreasByFormProject.art3d
	);
	return areas;
};
